module.exports = __webpack_public_path__ + "img/oh-elvas-icon-text.f6933692.svg";